import { Edit } from 'react-admin';
import { GoodsForm } from './Goods.Form';

export const GoodsEdit = () => {
    return (
        <Edit>
            <GoodsForm />
        </Edit>
    );
};
